import { useState } from "react";
import { Menu, X, Copy } from "lucide-react";
import { PumpkinMark } from "./Logo";
import { copyCA, CA_SHORT, BUY_URL } from "../lib/ca";

const links = [
  { id: "#lore", label: "Lore", testid: "nav-link-lore" },
  { id: "#tokenomics", label: "Tokenomics", testid: "nav-link-tokenomics" },
  { id: "#roadmap", label: "Roadmap", testid: "nav-link-roadmap" },
  { id: "#community", label: "Community", testid: "nav-link-community" },
];

export default function Navbar({ onNavigate }) {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    onNavigate(id);
  };

  return (
    <header
      data-testid="nav-container"
      className="fixed left-0 right-0 top-0 z-50 border-b border-orange-500/20 bg-[#08060B]/85 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 sm:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => go("#hero")}
          className="flex items-center gap-3"
        >
          <PumpkinMark size={38} />
          <span className="font-cinzel text-lg font-black tracking-wide text-zinc-100">
            FOMO<span className="text-pumpkin">WEEN</span>
          </span>
          <span className="hidden rounded-full border border-orange-500/40 bg-pumpkin/10 px-2.5 py-1 font-mono text-[10px] font-semibold tracking-widest text-orange-300 sm:inline-block">
            $FOMOWEEN
          </span>
        </button>

        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-zinc-400 transition-colors hover:text-pumpkin"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <button
            data-testid="nav-ca-badge"
            onClick={copyCA}
            className="flex items-center gap-2 rounded-full border border-purple-500/30 bg-elevated px-4 py-2 font-mono text-[11px] font-semibold uppercase tracking-widest text-purple-300 transition-colors hover:border-purple-400/60"
          >
            <Copy size={12} className="shrink-0" /> <span className="whitespace-nowrap">CA: {CA_SHORT}</span>
          </button>
          <span className="hidden items-center gap-2 whitespace-nowrap rounded-full border border-orange-500/30 px-4 py-2 font-mono text-[11px] uppercase tracking-widest text-orange-300 xl:flex">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-pumpkin opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-pumpkin" />
            </span>
            Spooky season is live
          </span>
          <a
            data-testid="nav-cta-buy"
            href={BUY_URL}
            target="_blank"
            rel="noreferrer"
            className="whitespace-nowrap rounded-full bg-pumpkin px-5 py-2.5 font-syne text-xs font-bold uppercase tracking-widest text-abyss transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_0_25px_rgba(255,107,0,0.5)]"
          >
            Buy $FOMOWEEN
          </a>
        </div>

        <button
          data-testid="nav-mobile-menu-btn"
          aria-label="Toggle menu"
          className="text-zinc-200 lg:hidden"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-orange-500/20 bg-[#0B0814] px-6 py-6 lg:hidden">
          <div className="flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`${l.testid}-mobile`}
                onClick={() => go(l.id)}
                className="text-left font-mono text-sm font-semibold uppercase tracking-[0.25em] text-zinc-300 transition-colors hover:text-pumpkin"
              >
                {l.label}
              </button>
            ))}
            <a
              data-testid="nav-cta-buy-mobile"
              href={BUY_URL}
              target="_blank"
              rel="noreferrer"
              className="mt-2 rounded-full bg-pumpkin px-5 py-3 text-center font-syne text-xs font-bold uppercase tracking-widest text-abyss"
            >
              Buy $FOMOWEEN
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
